import React from 'react';
import useTirePressure from '@di-shared/features/diag/tire/useTirePressure';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {TirePressureAccuracy} from '@di-shared/features/diag/tire/const';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

interface AdditionalTextProps {
  vin: string;
}

const standardTemperature = 20;
const temperatureUnit = '°C';

function AdditionalText({vin}: AdditionalTextProps) {
  const {t} = useInferableTranslation();
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();

  const {updatedTime, outSideTemperature, tirePressureAccuracy} = useTirePressure(vin);
  const formattedTireTime = updatedTime ? CldrDatetimeFormatter.format(updatedTime, 'yMMMaHM') : '';
  const roundedOutSideTemperature = Math.round(outSideTemperature);

  // TODO: 단위 변할 때 대비

  if (tirePressureAccuracy === TirePressureAccuracy.LOW) {
    return (
      <ul className="notice_list">
        <li className="notice_item">{t('T30010_$temperature', {temperature: standardTemperature + temperatureUnit})}</li>
        <li className="notice_item">
          {t('T30011_$date_$temperature', {
            date: formattedTireTime,
            temperature: roundedOutSideTemperature + temperatureUnit,
          })}
        </li>
      </ul>
    );
  }
  if (tirePressureAccuracy === TirePressureAccuracy.ACCURATE) {
    return (
      <ul className="notice_list">
        <li className="notice_item">{t('T30010_$temperature', {temperature: standardTemperature + temperatureUnit})}</li>
        <li className="notice_item">
          {t('T30012_$date_$temperature', {
            date: formattedTireTime,
            temperature: roundedOutSideTemperature + temperatureUnit,
          })}
        </li>
      </ul>
    );
  }
  if (tirePressureAccuracy === TirePressureAccuracy.HIGH) {
    return (
      <ul className="notice_list">
        <li className="notice_item">{t('T30010_$temperature', {temperature: standardTemperature + temperatureUnit})}</li>
        <li className="notice_item">
          {t('T30013_$date_$temperature', {
            date: formattedTireTime,
            temperature: roundedOutSideTemperature + temperatureUnit,
          })}
        </li>
      </ul>
    );
  }
  if (tirePressureAccuracy === TirePressureAccuracy.UNKNOWN) {
    return (
      <ul className="notice_list">
        <li className="notice_item">{t('T30010_$temperature', {temperature: standardTemperature + temperatureUnit})}</li>
      </ul>
    );
  }
  throw new Error('invalid cstaAvg');
}

export default AdditionalText;

export function AdditionalTextLoading() {
  const {t} = useInferableTranslation();
  return (
    <ul className="notice_list skeleton">
      <li className="notice_item">{t('T30010_$temperature', {temperature: standardTemperature + temperatureUnit})}</li>
      <li className="notice_item">
        {t('T30013_$date_$temperature', {
          date: '',
          temperature: '',
        })}
      </li>
    </ul>
  );
}
